module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-woman-50@2x_cd63151454039588152a22ff7d83148b.png";